<template>
  <div class="recipient">
    <h4><i class="icon-arrow-bar-right text-yellow"></i>{{ $lang.translate('track.header.recipient') }}:</h4>
    <p>
      <span v-if="result.to.name">{{ result.to.name }}</span>
      <span v-if="result.to.street">{{ result.to.street }}</span>
      <span v-if="result.to.zipAndCity">{{ result.to.zipAndCity }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Recipient',
  props: {
    result: {
      type: Object,
      required: true
    }
  }
}
</script>
<style scoped>
.recipient p span {
  display: block;
}
</style>